define('viewModels/privileged/composer/forms/formEditor/MultipleChoiceQuestion',[
    'lib/lodash4',
    'lib/knockout',
    'viewModels/privileged/composer/forms/formEditor/BaseQuestion',
    'viewModels/privileged/composer/forms/formEditor/MultipleChoiceQuestionAnswer',
    'viewModels/privileged/composer/vmUtils',
    'viewModels/privileged/composer/EntitySubviewMixinProvider',
    'viewModels/privileged/composer/VisibilityConditionMixinProvider'
], function (
    _,
    ko,
    BaseQuestionViewModel,
    MultipleChoiceQuestionAnswerViewModel,
    utils,
    EntitySubviewMixinProvider,
    VisibilityConditionMixinProvider
) {
    'use strict';

    var MultipleChoiceQuestionViewModel = BaseQuestionViewModel.extend(function multiChoiceVM_init(questionModel, namesList, formEditorState, questionMap) {
        var self = this;

        self.answerOptions = utils.subviewList(self, questionModel.answerOptions, MultipleChoiceQuestionAnswerViewModel, formEditorState);

        var entitySubviewMixinProvider = new EntitySubviewMixinProvider(self, "MultipleChoiceQuestionAnswer", questionModel.answerOptions, self.answerOptions, {modifiedState: formEditorState.isModified, handleSelection: true});

        //self.moveMultipleChoiceQuestionAnswer(start, end);
        //self.triggerMoveMultipleChoiceQuestionAnswerUp
        //self.triggerMoveMultipleChoiceQuestionAnswerDown
        entitySubviewMixinProvider.addReorderMethods();

        //self.triggerDeleteMultipleChoiceQuestionAnswer
        //self.deleteMultipleChoiceQuestionAnswer(index)
        entitySubviewMixinProvider.addDeleteMethods();

        self.canEnableVisibilityCondition = self.computed(function () {
            return self.getQuestionOptions().length > 0;
        });

        var visibilityConditionMixinProvider = new VisibilityConditionMixinProvider(self);
        visibilityConditionMixinProvider.addVisibilityConditions(questionMap, questionModel, self.getQuestionOptions, formEditorState);

        var baseValidateCanMoveUp = self.validateCanMoveUp;
        self.validateCanMoveUp = function(questionViewList) {
            if (!baseValidateCanMoveUp(questionViewList)) {
                return false;
            }

            var predicateViewConflicts = self.getPredicateViewsWithQuestion(questionModel.index() - 1);
            if (predicateViewConflicts.length) {
                var errors = _.map(predicateViewConflicts, function (predicateView) {
                    return {
                        messageKey: 'composer.evaluations.editor.moveUpValidation.question.predicateConflict',
                        questionIndex: questionModel.index() + 1, // Switch to 1-based indexes for error strings
                        questionGroupIndex: questionModel.questionGroupIndex() + 1,
                        predicateQuestionIndex: predicateView.selectedQuestion().index() + 1,
                        predicateQuestionGroupIndex: predicateView.selectedQuestion().questionGroupIndex() + 1
                    };
                });
                formEditorState.validationErrors(errors);
            }
            return predicateViewConflicts.length === 0;
        };

        var baseValidateCanMoveDown = self.validateCanMoveDown;
        self.validateCanMoveDown = function(questionViewList) {
            if (!baseValidateCanMoveDown(questionViewList)) {
                return false;
            }

            // Method may not exist if question type doesn't support it
            var nextQuestionView = questionViewList()[questionModel.index() + 1];

            // Make sure this question type supports visibility conditions.
            var predicateViewConflicts = nextQuestionView.canEnableVisibilityCondition() ?
                                             nextQuestionView.getPredicateViewsWithQuestion(questionModel.index()) :
                                             [];

            if (predicateViewConflicts.length) {
                var errors = _.map(predicateViewConflicts, function () {
                    return {
                        messageKey: 'composer.evaluations.editor.moveDownValidation.question.predicateConflict',
                        questionIndex: questionModel.index() + 1, // 1-based index for error strings
                        questionGroupIndex: questionModel.questionGroupIndex() + 1,
                        predicateQuestionIndex: nextQuestionView.index() + 1,
                        predicateQuestionGroupIndex: nextQuestionView.questionGroupIndex() + 1
                    };
                });
                formEditorState.validationErrors(errors);
            }
            return predicateViewConflicts.length === 0;
        };

        // property to indicate the multiple choice answer that was selected
        //   Live Scoring
        self.answerId = self.computed({
            read: function () {
                return questionModel.answerId();
            },
            write: function (value) {
                var oldAnswerId = questionModel.answerId();
                questionModel.answerId(value);
                _.each(self.answerOptions(), function (opt) {
                    if (opt.modelId === value) {
                        self.answer(opt.text());
                    }
                });
                if (oldAnswerId !== value) {
                    formEditorState.hasScoreChanged(true);
                }
            }
        });

        //Critical question; unsets kill question when unset.
        self.isCritical = self.computed({
            read: function() {
                return questionModel.isCritical();
            },
            write: function (newVal) {
                questionModel.isCritical(newVal);
                if(!newVal) {
                    //Can't be a kill question if not critical
                    questionModel.isKill(false);
                }
                formEditorState.isModified(true);
            }
        });

        //Critical questions, by definition, can only have two answer options
        self.criticalEnabled = self.computed(function () {
            return self.answerOptions().length == 2;
        });

        // This property only gets set when fillQualityAnswerData() is called.
        self.isKill = formEditorState.trackModified(self, questionModel.isKill);

        self.failedKillQuestion = ko.observable(false);

        self.selectDefaultAnswer = function(defaultAnswerOptions) {

            if(defaultAnswerOptions.na && self.isNaEnabled()) {
                self.naSelected(true);
            }
            else if(defaultAnswerOptions.highest) {
                //_.sortBy is a stable sort; it preserves order of equal elements; so this will default to the first highest scoring answer
                //    if multiple highest scoring answers exist
                var defaultAnswer = _.sortBy(self.answerOptions(), [function (answer) {
                    var negated = -1 * answer.value(); //Negating, since sort is ascending
                    return isNaN(negated) ? 1 : negated; //Replacing NaN with 1, to sort it last
                }])[0];

                if(defaultAnswer) {
                    //Select the answer based on id
                    self.answerId(defaultAnswer.modelId);
                }
            }
        };

        // Override the isSelected to count this question as selected if one of its answers is selected
        self.isSelected = self.computed(function multipleChoiceQuestionVM_isSelected() {
            var selectedItem = formEditorState.selectedItem();
            if (selectedItem === questionModel.modelId || selectedItem === self.id) {
                return true;
            }
            var answerOptions = self.answerOptions();
            for (var i = 0; i < answerOptions.length; i++) {
                var curAnswer = answerOptions[i];
                if (formEditorState.selectedItem() === curAnswer.modelId) {
                    return true;
                }
            }
            return false;
        });

        // Override base hasStatus behavior to include critical/kill and visibility conditions
        var baseHasStatus = self.hasStatus;
        self.hasStatus = self.computed(function () {
            return baseHasStatus() ||
                self.isCritical && self.isCritical() ||
                self.visibilityConditionEnabled();
        });

        var naLastAnswerId;
        //extends the base onNASelected behavior to also handle answer id
        var baseNASelected = self.onNASelected;
        self.onNASelected = function multiChoiceNASelected(naSelected) {
            baseNASelected(naSelected);
            if (naSelected) {
                naLastAnswerId = self.answerId();
                self.answerId('');
                return;
            }
            self.answerId(naLastAnswerId);
        };

        // Resets the question to initial unanswered state
        //  extends impl in BaseQuestion to also clear answer id
        var baseClearResponse = self.clearResponse;
        self.clearResponse = function () {
            baseClearResponse();
            naLastAnswerId = '';
            self.answerId('');
        };

        //Triggered on question properties
        self.prependMultipleChoiceQuestionAnswer = function () {
            self.addMultipleChoiceQuestionAnswer(0);
        };

        //Triggered from answer; inserts after existing answer
        self.insertMultipleChoiceQuestionAnswer = function (data, evt) {
            var context = ko.contextFor(evt.target);
            var idx = context.$index();
            self.addMultipleChoiceQuestionAnswer(idx+1);
        };

        self.addMultipleChoiceQuestionAnswer = function (index) {
            questionModel.addMultipleChoiceQuestionAnswer(index);
            formEditorState.isModified(true);
            self.answerOptions()[index].select();
        };

        // Get the answers in a form that quality can use them.  Transform attribute names
        // Do NOT call any superclass methods - each subclass is in control of how it wants to return data
        self.getQualityAnswerData = function() {
            return {
                questionId: questionModel.id,
                answerId: self.answerId(),
                markedNA: self.naSelected(),
                comments: questionModel.comments()
            };

        };

        var baseFillQualityAnswerData = self.fillQualityAnswerData;
        self.fillQualityAnswerData = function(qualityQuestionAnswerData) {
            if (qualityQuestionAnswerData) {
                baseFillQualityAnswerData(qualityQuestionAnswerData);
                if (qualityQuestionAnswerData.answerId) { //Check so that we don't override an NA answer
                    self.answerId(qualityQuestionAnswerData.answerId);
                    if (qualityQuestionAnswerData.failedKillQuestion) {
                        self.failedKillQuestion(qualityQuestionAnswerData.failedKillQuestion);
                    }
                }
            }
        };

        self.subscribe(self.visibilityConditionVisible, function (isVisible) {
            if (!isVisible) {
                self.clearResponse();
            }
        });

    }, true); //flag indicates that the model should be passed to the parent constructor

    return MultipleChoiceQuestionViewModel;
});

